import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromPigGuide from '../fromPigProductGuide.barrel';

export const selectState = createFeatureSelector<fromPigGuide.State>(fromPigGuide.pigProductGuideFeatureKey);

export const selectPigFamilies = createSelector(selectState, state => state.pigFamilies);
export const selectPigDiameters = createSelector(selectState, state => state.pigDiameters);

export const selectPigProductOdataResponse = createSelector(selectState, state => state.pigProducts);
export const selectPigProductOdataValue = createSelector(selectPigProductOdataResponse, resp => resp?.value || []);
export const selectPigProductOdataTotalCount = createSelector(selectPigProductOdataResponse, resp => resp?.['@odata.count'] || 0);

export const selectGuideFilters = createSelector(selectState, state => state.guideFilters);
export const selectFamilyId = createSelector(selectGuideFilters, filters => filters?.familyId);
export const selectConfigurationId = createSelector(selectGuideFilters, filters => filters?.configurationId);
export const selectDiameterId = createSelector(selectGuideFilters, filters => filters?.diameterId);
export const selectPartNumber = createSelector(selectGuideFilters, filters => filters?.partNumber);
export const selectPreferredProducts = createSelector(selectGuideFilters, filters => filters?.preferredProducts);
export const selectProductName = createSelector(selectGuideFilters, filters => filters?.productName);
export const selectRealSealCup = createSelector(selectGuideFilters, filters => filters?.realSealCup);
export const selectBidirectional = createSelector(selectGuideFilters, filters => filters?.bidirectional);
export const selectMinimumMetal = createSelector(selectGuideFilters, filters => filters?.minimumMetal);
export const selectBodyBypass = createSelector(selectGuideFilters, filters => filters?.bodyBypass);
export const selectRebuildable = createSelector(selectGuideFilters, filters => filters?.rebuildable);
export const selectWaxParaffin = createSelector(selectGuideFilters, filters => filters?.waxParaffin);
export const selectMagnet = createSelector(selectGuideFilters, filters => filters?.magnet);

export const pigFamilyConfigurations = createSelector(selectState, state => state.pigFamilyConfigurations);
export const selectPigFamilyConfigurations = createSelector(selectFamilyId, pigFamilyConfigurations, (familyId, familyConfigs) =>
  (familyConfigs || []).filter(configs => configs.pigFamilyId === (familyId || -1)));

export const selectedPigFamilyConfigurationsIds = createSelector(selectPigFamilyConfigurations, configs => configs.map(c => c.id));
export const defaultOdataFilter = (currentDate: Date) => createSelector(selectState, state => `(inactiveDate eq null OR inactiveDate lt ${currentDate.getFullYear()}-${(currentDate.getMonth() + 1).toString().padStart(2, '0')}-${(currentDate.getDate()).toString().padStart(2, '0')}) AND showInSelector eq 1 AND `);

export const selectOdataFilter = (currentDate: Date) => createSelector(defaultOdataFilter(currentDate), selectGuideFilters, selectedPigFamilyConfigurationsIds, (defaultFilter, filters, configIds) => {
  let res = defaultFilter;
  if ((filters?.familyId || -1) > -1 && configIds.length > 0) res += `configurationId in (${configIds.join(',')}) AND `;
  if ((filters?.partNumber || '').length > 0) res += `contains(partNumber, '${filters?.partNumber}') AND `;
  if ((filters?.productName || '').length > 0) res += `contains(productName, '${filters?.productName}') AND `;
  if ((filters?.diameterId || -1) > -1) res += `diameterId eq ${filters?.diameterId} AND `;
  if ((filters?.configurationId || -1) > -1) res += `configurationId eq ${filters?.configurationId} AND `;
  if (!!filters?.preferredProducts) res += `preferredProduct eq 1 AND `;
  if ((!!filters?.realSealCup || -1) > -1) res += `realSealCup eq ${filters?.realSealCup} AND `
  if ((!!filters?.bidirectional || -1) > -1) res += `bidirectional eq ${filters?.bidirectional} AND `
  if ((!!filters?.minimumMetal || -1) > -1) res += `minimumMetal eq ${filters?.minimumMetal} AND `
  if ((!!filters?.bodyBypass || -1) > -1) res += `bodyBypass eq ${filters?.bodyBypass} AND `
  if ((!!filters?.rebuildable || -1) > -1) res += `rebuildable eq ${filters?.rebuildable} AND `
  if ((!!filters?.waxParaffin || -1) > -1) res += `waxParaffin eq ${filters?.waxParaffin} AND `
  if ((!!filters?.magnet || -1) > -1) res += `magnet eq ${filters?.magnet} AND `

  return res.substring(0, res.length - 5);
});

export const selectPigProductOdataParams =
  (currentDate: Date) => createSelector(selectState, selectOdataFilter(currentDate), (state, filters) => ({
    ...state?.pigProductParams,
    filter: filters
  }));
export const selectTop = (currentDate: Date) => createSelector(selectPigProductOdataParams(currentDate), parms => parms.top);
export const selectCurrentPage = (currentDate: Date) => createSelector(selectPigProductOdataParams(currentDate), q => q.skip === 0 ? 1 : Math.ceil((q.skip / q.top) + 1));

export const selectGuideLoaders = createSelector(selectState, state => state.loaders);
export const selectGuideLoader = (name: fromPigGuide.Loaders) =>
  createSelector(selectGuideLoaders, (loaders: fromPigGuide.Loaders[]) => !!((loaders || []).find(f => f === name)));


